export default __webpack_public_path__ + "static/portfolio-l6-img-1-83ca21198cfc1a727b333332b79f159f.png";